var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_6",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_6",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAB2UlEQVRIie3VT28NURjH8WdYsMECEUFY+RM0YUVERNuUWEg0Eu9BQuysvBFJvQAJVjZ2Wkk1Flai7pJKUAmp+ldNPxZ3Jh3NPXem947Gwje5yc05z/l9z8wzcybiP2tEVlWAvRExGhEjEbE/InbkU+8iohURjyLifpZlrxvZEXbjDhZUs4Ax7OpXegEfawhXMovzvUov4lcP0oJFjK5Wegzf+5AWfMNAXWmG8QakBU9Q+fAGRhqUFgynfOtK/68kak5lFUTE6cTaVOYf4hM1alKkbunJygWYi4hNNSSr4UuWZZs7TZSvRsPSiIil1ERZ/CZRk+xxpHtbMFNHPFWjZiVVr8tkRAQGcbBjBYb+wus0lGePoYWNncQZJhqUTuSZW/ApH7uRuuojmjkyv+JonnmrNP402RTtE+xHH9JFXMqzDmuf2wVzXZ8ITPYo/YBzecZWvFgx/7mbdLgH4U/cxs48Yzued6ibTEkH8L5UOIUzuIqHeIn5/NfKx65hTynjLGYSG7yeErfyRfcwqs5nbXntIdzFUkL6Chvq5nUTbdNuy838znRjHgf6lubifXhcISxYwmAj4tIGhrVPpmnL/Z/Ox56V5LM43qi8y6bW4zIe4C1aayL+J/kNLtkkj5Sn0rcAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon__chat.e28336df7b827dd87ecb9457102b7892.svg";
export { ForwardRef as ReactComponent };